<template>
  <div class="full-screen" title="">

    <router-link :to="`../../`" class="close"><span class="close__title">Esc</span></router-link>

    <div class="add-pharmacy-wrapper">

      <div class="pre-title">Копирование полки</div>




      <div style="text-align: center">

        <p style="margin-bottom: 20px">
          <select-material
                  :isMulti="false"
                  :title="`Аптека`"
                  :possibleValues="pharmaciesList"
                  :allowSearch="true"
                  @select="pharmacy = $event"
          ></select-material>
        </p>
        <p style="margin-bottom: 20px">
        <select-material
                :isMulti="false"
                :title="`Стеллаж`"
                :possibleValues="rackList"
                @select="rack = $event"
        ></select-material>
        </p>
        <p>

        <select-material
                :isMulti="false"
                :title="`Полка`"
                :possibleValues="shelfList"
                @select="shelf = $event"
        ></select-material>
        </p>
      </div>

      <div class="" style="text-align: center; margin-top: 20px;">

        <a href="#" @click.prevent="copy()" class="button">Копировать</a>

      </div>

    </div>




  </div>
</template>


<script type="text/javascript">
  import axios from 'axios';
  import selectMaterial from '../html/SelectMaterial';

  export default {
    name: 'rack-add',
    created() {
      this.loadPharmacies();
    },
    watch: {
      pharmacy() {
        this.loadRacks();
      },
      rack() {
        this.loadShelfs();
      },
    },
    methods: {
      loadPharmacies() {
        const that = this;
        axios.get('/api/v2/pharmacies/').then((response) => {
          that.pharmaciesList = response.data;
        });
      },
      loadRacks() {
        const that = this;
        that.rackList = [];
        that.shelfList = [];
        if (that.pharmacy !== '') {
          axios.get(`/api/v2/racks/?pharmacy=${that.pharmacy}`).then((response) => {
            that.rackList = response.data;
          });
        }
      },
      loadShelfs() {
        const that = this;
        that.shelfList = [];
        if (that.rack !== '') {
          axios.get(`/api/v2/shelfs/?rack=${that.rack}`).then((response) => {
            that.shelfList = response.data.results.map((shelf, index) => {
              const t = Object.assign(shelf);
              t.title = response.data.results.length - index;
              return t;
            });
          });
        }
      },
      copy() {
        axios.post('/api/copyShelf/', {
          toId: this.shelf,
          fromId: this.$route.params.shelf,
        }).then(() => {
          this.$router.push('../../');
        });
      },
    },
    data() {
      return {
        pharmacy: '',
        pharmaciesList: [],
        rack: '',
        rackList: [],
        shelf: '',
        shelfList: [],

      };
    },
    components: { selectMaterial },
  };
</script>


<style type="text/css" lang="less" scoped>

  .material-select__title{
    min-width: 400px !important;
  }

.material-select__values{
  max-width: 400px !important;
}



</style>


// WEBPACK FOOTER //
// CopyShelf.vue?5e53f71e